import React from 'react';
import NotificationsPage from '../common/NotificationsPage';

const BuyerNotifications = () => <NotificationsPage title="Notifications" />;

export default BuyerNotifications;
